import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { isEqual } from 'lodash-es';
import { Strike, UserStrikes } from '@bluecrew/crew-member-backend-angular-client';
import { PolicyClientService } from './clients/policy-client.service';

export interface StoredStrikes {
  viewedOn: number;
  strikes: Strike[];
}

@Injectable({
  providedIn: 'root',
})
export class CachedPolicyStrikeClientService {
  private readonly ACKNOWLEDGE_STRIKE_STORAGE_KEY = 'acknowledgedStrikes';
  private readonly COOLDOWN_IN_MINUTES = 10;

  constructor(private readonly policyClient: PolicyClientService, private readonly storage: Storage) {}

  async getUnacknowledgedStrikes(): Promise<UserStrikes> {
    const apiStrikes = await this.policyClient.getUnacknowledgedStrikes();

    let strikes = apiStrikes.strikes;
    // check storage to verify if strikes should be returned
    const storedStrikesWithTime = (await this.storage.get(this.ACKNOWLEDGE_STRIKE_STORAGE_KEY)) as StoredStrikes;
    const storedStrikes = storedStrikesWithTime?.strikes || [];
    const cooldownDate = Date.now() - this.COOLDOWN_IN_MINUTES * 60 * 1000;
    if (
      storedStrikesWithTime?.viewedOn > cooldownDate &&
      apiStrikes.strikes.every((strike) => storedStrikes.some((storedStrike) => isEqual(strike, storedStrike)))
    ) {
      strikes = [];
    }

    return { ...apiStrikes, strikes: strikes };
  }

  async updateViewed(strikes: Strike[]) {
    await this.storage.set(this.ACKNOWLEDGE_STRIKE_STORAGE_KEY, {
      viewedOn: Date.now(),
      strikes,
    } as StoredStrikes);
  }
}
